module.exports = __webpack_public_path__ + "static/media/wsa.7d08711f.png";